import * as React from "react";

// Soft UI Dashboard PRO React components
import SoftBox from "../SoftBox";
import SoftProfile from "../ProfilePictures/SoftProfile";

const Note = ({
  name = "Sample Name",
  date = "November 24, 2023",
  note = "Hello!",
  profile
}) => {
  return (
    <div style={{ display: "flex", width: "100%", marginTop: "16px" }}>
      {/** Profile */}
      <div style={{ paddingRight: "8px" }}>
        <SoftProfile
          size="sm"
          src={profile}
        />
      </div>

      {/** Message details */}
      <div style={{
        minHeight: "70px",
        width: "100%"
      }}>
        <SoftBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            "& div": {
              fontStyle: "normal",
            },
            "& div:first-child": {
              color: "#344054",
              fontSize: "12px",
              fontWeight: "600",
              lineHeight: "14px"
            },
            "& div:last-child": {
              color: "#98A2B3",
              fontSize: "11px",
              fontWeight: "400",
              lineHeight: "14px",
              whiteSpace: "nowrap"
            }
          }}
        >
          {/** Name */}
          <div>
            {name}
          </div>

          {/** Date and Time */}
          <div>
            {date}
          </div>
        </SoftBox>

        {/** Note content */}
        <div
          style={{
            padding: "10px 12px",
            marginTop: "6px",
            borderRadius: "10px",
            border: "1px solid #EAECF0",
            backgroundColor: "#F9FAFB",
            color: "#344054",
            fontSize: "13px",
            fontWeight: 400,
            lineHeight: "18px",
            wordBreak: "break-word",
          }}
        >
            {note}
        </div>
      </div>
    </div>
  )
};

export default Note;
